import EditorRoutes from 'foundation/EditorRoutes';
import {RouteBundle} from 'routing/RouteConstants';

export const AnalysesRoutes: RouteBundle = {
  domain: 'analyses',
  routes: [
    {
      urlPattern: 'analytics/analyses/:analysisUrlIdentifier',
      handler: EditorRoutes.analysisEditor.bind(EditorRoutes),
      legacy: true,
    },
  ],
};
